import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ngSwitchMultiCase' })
export class NgSwitchMultiCasePipe implements PipeTransform {
    transform(value: any, ...args: string[]): any {
        return args.includes(value) ? value : undefined;
    }
}
